import { render, staticRenderFns } from "./SystemSettingsPolicyDepositLimit.vue?vue&type=template&id=c105aca0&scoped=true"
import script from "@/scripts/modal/systemSettingsPolicyDepositLimit.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/systemSettingsPolicyDepositLimit.js?vue&type=script&lang=js&external"
import style0 from "./SystemSettingsPolicyDepositLimit.vue?vue&type=style&index=0&id=c105aca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c105aca0",
  null
  
)

export default component.exports